<template>
  <div>
    <div class="text-right mb-1">
      <b-button
        variant="outline-primary"
        pill
        @click="createEcl"
        v-if="hasPermission('create_emergency_contact_list')"
      >
        <feather-icon icon="PlusIcon" class="mr-50" />
        <span class="align-middle">Add New</span>
      </b-button>
    </div>

    <b-card class="mt-3">
      <b-row class="mb-1" align-v="center">
        <b-col md="7">
          <div v-if="searchType">
            <b-form-group
              label="Site"
              label-for="site"
              class="w-50"
              v-if="searchType.value === 1"
            >
              <v-select
                label="name"
                v-model="site"
                placeholder="Select Site"
                :options="sites"
                autoscroll
                :clearable="true"
              ></v-select>
            </b-form-group>

            

            <b-form-group
              label="Building"
              label-for="building"
              class="w-50"
              v-if="searchType.value === 2"
            >
              <v-select
                label="name"
                v-model="building"
                placeholder="Select Building"
                :options="buildings"
                autoscroll
                :clearable="true"
              ></v-select>
            </b-form-group>
          </div>
        </b-col>
        <b-col md="3">
          <b-form-group label="Search Type" label-for="searchType">
            <v-select
              id="searchType"
              v-model="searchType"
              :options="searchTypes"
              placeholder="Search Type"
              label="name"
            />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-button variant="primary" pill @click="search">
            <feather-icon icon="SearchIcon" class="mr-50" />
            <span class="align-middle">Search</span>
          </b-button>
        </b-col>
      </b-row>
      <b-table
        responsive="sm"
        :fields="fields"
        :items="ecls"
        details-td-class="m-0 p-0"
        small
        v-if="hasPermission('read_emergency_contact_list')"
        :per-page="0"
      >
        <template #cell(site_data)="row">
          {{
            row.item.site_data ? row.item.site_data.name : ""
          }}
        </template>


        <template #cell(building_data)="row">
          {{
            row.item.building_data ? row.item.building_data.name : ""
          }}
        </template>
        
        <template #cell(manage)="row">
          <b-button
            variant="success"
            pill
            size="sm"
            class="mr-50"
            @click="editEcl(row.item)"
            v-if="hasPermission('update_emergency_contact_list')"
          >
            Edit
          </b-button>
        </template>
      </b-table>
      <b-pagination
        size="md"
        :total-rows="totalItems"
        v-model="currentPage"
        :per-page="perPage"
      ></b-pagination>
    </b-card>
    <CreateEclModal
      @modalClosed="onModalClosed"
      :key="`create-${createEclModalCount}`"
    />
    <EditEclModal
      :ecl="ecl"
      @modalClosed="onModalClosed"
      :key="`edit-${editEclModalCount}`"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VueSelectPaginated from "@/components/ui/VueSelectPaginated.vue";
import CreateEclModal from "@/components/ecl/CreateEclModal.vue";
import EditEclModal from "@/components/ecl/EditEclModal.vue";
import util from "@/util.js";
import VueGauge from 'vue-gauge';


export default {
  components: {
    CreateEclModal,
    EditEclModal,
    VueSelectPaginated,
    VueGauge,
  },
  data() {
    return {
      fields: [
        { key: "site_data", label: "Site" },
        { key: "building_data", label: "Building" },
        { key: "nearest_medical_center", label: "Medical Centre" },
        { key: "nearest_medical_center_contact", label: "Medical Centre Contact number" },
        { key: "nearest_medical_hospital", label: "Hospital" },
        { key: "nearest_medical_hospital_contact", label: "Hospital Contact number" },
        { key: "manage", label: "Actions" },
      ],
      currentPage: 1,
      perPage: 0,
      totalItems: 0,
      ecls: [],
      ecl: null,
      createEclModalCount: 0,
      editEclModalCount: 0,
      searchTypes: [
        { value: 1, name: "Site" },
        { value: 2, name: "Building" },
      ],
      searchType: null,
      name: "",
      counts : "",
      sites: [],
      site: "",
      buildings: [],
      building: "",
    };
  },
  mixins: [util],
  created() {
    this.searchType = this.searchTypes[0];
  },
  async mounted() {
    await this.fetchPaginatedData();
    const counter = await this.getCounter();
    this.counts = counter.data;

    const sites =  await this.getSitesDDL();
    this.sites = sites.data;

    const buildings =  await this.getBuildingsDDL();
    this.buildings = buildings.data;

  },
  methods: {
    ...mapActions({
      getCounter: "appData/getCounter",
      getEcls: "appData/getEcls",
      getSitesDDL: "appData/getSitesDDL",
      getBuildingsDDL: "appData/getBuildingsDDL",
    }),
    async search() {
      if (this.searchType) {
        switch (this.searchType.value) {
          case 1:
            this.building = "";
            break;
          case 2:
            this.site = "";
            break;
        }
      } else {
        this.site = "";
        this.building = "";
      }
      this.currentPage = 1;
      await this.fetchPaginatedData();
    },
    async fetchPaginatedData() {
      try {
        const res = await this.getEcls({
          pageNumber: this.currentPage,      
          site: this.site,      
          building: this.building,      
        });
        this.ecls = res.data.results;
        console.log(this.ecls);
        this.totalItems = res.data.count;
        this.perPage = res.data.per_page;
      } catch (error) {
        this.displayError(error);
      }
    },
    createEcl() {
      this.createEclModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("create-ecl-modal");
      });
    },
    editEcl(ecl) {
      this.ecl = ecl;
      this.editEclModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("edit-ecl-modal");
      });
    },
    async removeEcl(ecl) {
      this.ecl = ecl;
      try {
        const res = await this.deleteEcl({
          pk: this.ecl.id,
        });
        if (res.status === 204) {
          this.$swal({
            title: "Ecl deleted successfully",
            icon: "success",
          });
          if (
            (this.totalItems - 1) % this.perPage === 0 &&
            this.currentPage !== 1
          ) {
            this.currentPage -= 1;
          } else {
            await this.fetchPaginatedData();
          }
        }
      } catch (error) {
        this.displayError(error);
      }
    },
    async onModalClosed() {
      await this.fetchPaginatedData();
    },
  },
  computed: {
    ...mapGetters({
      hasPermission: "appData/hasPermission",
    }),
  },
  watch: {
    currentPage: async function (val) {
      await this.fetchPaginatedData();
    },
  },
};
</script>

<style></style>
